import { httpService } from 'core/services/httpService';   

export async function getBookingsList(businessId, options){
  return httpService.GET({url: `/${businessId}/booking`}, options);
}

export async function addNewBooking(businessId, body, options){
  return httpService.POST({url: `/${businessId}/booking`, body}, options);
}

export async function updateBooking(businessId, body, options){
  return httpService.PUT({url: `/${businessId}/booking`, body}, options);
}

export async function deleteBooking(businessId, bookingId, options){
  return httpService.DELETE({url: `/${businessId}/booking/${bookingId}`}, options);
}
